import React from "react";
import AuthenticatedLayout from "../layouts/AuthenticatedLayout";
import Logo from "../components/Logo";

export default function HomePage() {
	return (
		<AuthenticatedLayout title="">
			<div className="box mb-4 p-5 is-fluid">
				<h2 className="title is-2 mt-5 has-text-centered">Gestione Fatture</h2>
				<p className="subtitle my-5 has-text-centered">
					Benvenuto nella piattaforma per la gestione delle fatture del <strong>Gruppo Alpini di Atri</strong>.
				</p>
				<Logo className="mt-5" />
			</div>
		</AuthenticatedLayout>
	);
}
